const color = {
  white: '#FFFFFF',
  black: '#000000',
  primary_light: '#D4C4ED',
  primary_normal: '#8C4FF2',
  primary_dark: '#4812A3',
  gradation_dark: 'linear-gradient(225deg, #8C4FF2 0%, #4812A3 100%)',
  grayscale_ea: '#EAEAEA',
  grayscale_11: '#111111',
  grayscale_33: '#333',
  grayscale_88: '#888',
  grayscale_be: '#BEBEBE',
  grayscale_f5: '#F5F5F5',
  grayscale_6c: '#6C6C6C',
  error: '#EA0000',
  grayscale_d8: '#D8D8D8',
};

export default color;
